import PropTypes from "prop-types";

export const photoPropTypes = {
    id: PropTypes.number,
    created: PropTypes.string,
    mimetype: PropTypes.string,
    url: PropTypes.string,
};
